module.exports = __webpack_public_path__ + "img/portraits_03_V.4c349c72.webp";